import { injectIntl } from "react-intl";
import { withBrowser, browserShape } from "../../context";
import { intlShape } from "../../shapes";
import { isNotEmpty } from "../../utils";

type Props = {
  className?: string;
  id: string;
  fetching?: boolean;
  browser: browserShape;
  text?: string;
  target?: string;
  intl: intlShape;
  handleOnClick?: $TSFixMeFunction;
};

export function CancelButton({
  className = "",
  target,
  handleOnClick,
  id,
  text,
  fetching,
  intl,
  browser,
}: Props) {
  const onClick = () => {
    if (handleOnClick) {
      handleOnClick();
    } else if (target) {
      browser.navigateTo(target);
    } else {
      browser.goBack();
    }
  };

  const finalClassName = className
    ? `btn btn-default ${className}`
    : "btn btn-default";

  const displayText = isNotEmpty(text)
    ? text
    : intl.formatMessage({ id: "button.cancel" });

  return (
    <button
      id={id}
      data-testid="cancel-button-testid"
      name="submit"
      onClick={onClick}
      className={finalClassName}
      disabled={fetching}
      type="button"
    >
      {displayText}
    </button>
  );
}

export default injectIntl(withBrowser(CancelButton));
